import { Navigation } from "../Navigation";
import { BendHero } from "./BendHero";
import { BendWhatWeDo } from "./BendWhatWeDo";
import { BendWhyDifferent } from "./BendWhyDifferent";
import { BendProcess } from "./BendProcess";
import { BendWhoWeWorkWith } from "./BendWhoWeWorkWith";
import { BendGetStarted } from "./BendGetStarted";

export default function BendPage() {
  return (
    <div className="bg-white min-h-screen">
      <Navigation />
      <main>
        <BendHero />
        <BendWhatWeDo />
        <BendWhyDifferent />
        <BendProcess />
        <BendWhoWeWorkWith />
        <BendGetStarted />
      </main>
      <footer
        data-testid="footer"
        className="bg-[#0F172A] border-t border-[#1E293B]"
      >
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20 py-12 md:py-16">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
            <div>
              <span className="font-['Playfair_Display'] font-semibold text-2xl text-white">
                BLD
              </span>
              <p className="mt-2 text-[14px] text-[#475569]">
                Media buying and funnel building. That's it.
              </p>
            </div>
            <div className="flex flex-wrap gap-6 text-[14px] text-[#475569]">
              {[
                ["Services", "#what-we-do"],
                ["Process", "#process"],
                ["Clients", "#who-we-work-with"],
                ["Contact", "mailto:marketing@bldventuresgroup.com"],
              ].map(([label, href]) => (
                <a
                  key={label}
                  href={href}
                  onClick={href.startsWith("#") ? (e) => {
                    e.preventDefault();
                    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
                  } : undefined}
                  className="hover:text-white transition-colors"
                >
                  {label}
                </a>
              ))}
            </div>
          </div>
          <div className="mt-10 pt-8 border-t border-[#1E293B] flex flex-col sm:flex-row items-center justify-between gap-4 text-[13px] text-[#334155]">
            <p>BLD Marketing. All rights reserved.</p>
            <p>Two operators. Zero overhead.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
